import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Formik } from "formik";
import * as yup from "yup";

import { Row, Col, Image, Card, Form, Button } from "react-bootstrap";

import { authHandler } from "../redux/handlers";
import { STATUS } from "../constants/server/api";

export function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [inputtype, setInputtype] = useState("password");
  const [rememberedUsername, setRememberedUsername] = useState(() => {
    return localStorage.getItem("rememberedUsername") || "";
  });

  useEffect(() => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("rememberedUsername");
  }, []);

  const schema = yup.object().shape({
    username: yup.string().required("กรุณากรอกอีเมลหรือเบอร์โทรศัพท์"),
    password: yup.string().required("กรุณากรอกรหัสผ่าน"),
  });

  const handleLogin = async (values) => {
    try {
      const response = await dispatch(
        authHandler.login(values.username, values.password)
      );

      if (response === STATUS.OK) {
        if (values.remember) {
          localStorage.setItem("rememberedUsername", values.username);
        } else {
          localStorage.removeItem("rememberedUsername");
        }
        navigate("/customers");
      }
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  return (
    <div className="m-0 w-100 p-0 bg-white">
      <Row className="g-0 h-100vh">
        <Col xl={5} lg={6} className="d-none d-lg-block">
          <Image src="/images/cover_login.png" className="img-fit" />
        </Col>
        <Col xl={7} lg={6} className="d-flex flex-column py-4">
          <div className="mb-auto"></div>
          <Card className="card-login-st-1 mb-auto h-auto">
            <Card.Body>
              <div className="text-center">
                <Image src="/logo.png" width={150} className="mb-4 mx-auto" />
              </div>
              <div className="text-center text-[#FF731D] font-bold text-[24px] fw-5 mb-4">
                ADMIN SYSTEM
              </div>
              <Formik
                initialValues={{
                  username: rememberedUsername,
                  password: "",
                  remember: !!rememberedUsername,
                }}
                validationSchema={schema}
                onSubmit={handleLogin}
              >
                {({ handleSubmit, handleChange, touched, errors, values }) => (
                  <Form noValidate onSubmit={handleSubmit}>
                    <Form.Control
                      type="text"
                      name="username"
                      placeholder="อีเมลหรือเบอร์โทรศัพท์"
                      onChange={handleChange}
                      isValid={touched.username && !errors.username}
                      isInvalid={!!errors.username}
                      className="form-st-1 mb-4"
                      value={values.username}
                    />
                    <div className="position-relative">
                      <Form.Control
                        type={inputtype}
                        name="password"
                        placeholder="รหัสผ่าน"
                        onChange={handleChange}
                        isValid={touched.password && !errors.password}
                        isInvalid={!!errors.password}
                        className="form-st-1 mb-4"
                      />
                      <Button
                        type="button"
                        className="btn btn-change-type-password"
                        onClick={() =>
                          setInputtype(
                            inputtype === "password" ? "text" : "password"
                          )
                        }
                      />
                    </div>

                    <div className="d-flex align-items-center mb-4">
                      <div className="me-auto">
                        <Form.Check
                          name="remember"
                          type="checkbox"
                          id="remember"
                          label="จำรหัสผ่าน"
                          className="form-check-st-1"
                          checked={values.remember}
                          onChange={handleChange}
                        />
                      </div>
                      <div>
                        <a href="/forgot-password" className="alink-st-1">
                          ลืมรหัสผ่าน ?
                        </a>
                      </div>
                    </div>
                    <Button type="submit" className="btn-login w-100">
                      เข้าสู่ระบบ
                    </Button>
                  </Form>
                )}
              </Formik>
            </Card.Body>
          </Card>
          <div className="text-center fs-20 tc-3 d-flex align-items-end pt-4 justify-content-center">
            <span className="me-3">Power By</span>
            <div className="pb-05">
              <Image src="/images/logo_allder.png" width={98} />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
